import { IconCopy } from "@icons/index";
import { IconLineMultiplayer, IconLineShoppingBag } from "@kalodata/kds-design-icons";
import type { ReactNode } from "react";

type VideoRemakeCardKey = "video-remake" | "change-model" | "change-product";

interface VideoRemakeCardConfig {
  key: VideoRemakeCardKey;
  title: string;
  description: string;
  disabled?: boolean;
  renderIcon: (className: string) => ReactNode;
}

export const VIDEO_REMAKE_CARDS: VideoRemakeCardConfig[] = [
  {
    key: "video-remake",
    title: "Video Remake",
    description:
      "Clone the structure and winning formula of benchmark videos to generate your exclusive promotional content.",
    renderIcon: (className) => <IconCopy className={className} />,
  },
  {
    key: "change-model",
    title: "Swap Model",
    description: "Seamlessly swap the person in your video using advanced AI while preserving natural movements.",
    disabled: true,
    renderIcon: (className) => <IconLineMultiplayer size={28} className={className} />,
  },
  {
    key: "change-product",
    title: "Replace Product",
    description:
      "Replace or update products within your video clips with pixel-perfect integration and realistic lighting.",
    disabled: true,
    renderIcon: (className) => <IconLineShoppingBag size={28} className={className} />,
  },
];
